import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate, Outlet } from 'react-router-dom'
import { HOME } from '../../common/constants/routes'
import { isLcwOnlyUser } from '../../common/utils'

const MasterRoutes = ({ allowLcw = false }) => {
    const isMasterPassword = useSelector((state) => state.auth?.user?.isMasterPassword)
    const user = useSelector((state) => state.auth?.user?.user)

    return isMasterPassword || (allowLcw && isLcwOnlyUser(user)) ? <Outlet /> : <Navigate to={HOME} replace />
}

export default MasterRoutes
